export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1563199592-687f283ab0e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbiUyMHN0ZWRpbyUyMHBvcnRmb2xpbyUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3OTIzODUyMzd8MA&ixlib=rb-4.1.0&q=85",
  p1: "https://images.unsplash.com/photo-1691491918178-8a2e68b44919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbiUyMHN0dWRpbyUyMHBvcnRmb2xpbyUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3OTIzODUyMzd8MA&ixlib=rb-4.1.0&q=85",
  p2: "https://images.pexels.com/photos/8088379/pexels-photo-8088379.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  p3: "https://images.unsplash.com/photo-1710189966846-a94ce9b92736?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBmaWxtJTIwcHJvZHVjdGlvbiUyMHN0dWRpbyUyMHBvcnRmb2xpbyUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3OTIzODUyMzd8MA&ixlib=rb-4.1.0&q=85",
  p4: "https://images.pexels.com/photos/23384400/pexels-photo-23384400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  texture: "https://images.unsplash.com/photo-1693648793394-0b76b7eb042e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGRhcmslMjBhcnRpc3RpYyUyMHRleHR1cmUlMjBkZXNpZ258ZW58MHx8fHwxNzkyMzg1MjM5fDA&ixlib=rb-4.1.0&q=85",
  svcVideo: "https://images.pexels.com/photos/34516668/pexels-photo-34516668.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  svcBrand: "https://images.pexels.com/photos/8489951/pexels-photo-8489951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  svcProduct: "https://images.unsplash.com/photo-1590605095243-072811dbe64c?crop=entropy&cs=srgb&fm=jpg&q=85",
  svcSocial: "https://images.pexels.com/photos/11809800/pexels-photo-11809800.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  svcWeb: "https://images.pexels.com/photos/34803985/pexels-photo-34803985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  afterlight: "https://images.pexels.com/photos/7850600/pexels-photo-7850600.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  nocturne: "https://images.pexels.com/photos/37707691/pexels-photo-37707691.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  terraforma: "https://images.pexels.com/photos/15923679/pexels-photo-15923679.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pulse: "https://images.unsplash.com/photo-1605296867724-fa87a8ef53fd?crop=entropy&cs=srgb&fm=jpg&q=85",
  social1: "https://images.pexels.com/photos/7194623/pexels-photo-7194623.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  social2: "https://images.unsplash.com/photo-1704018453307-d563498b585b?crop=entropy&cs=srgb&fm=jpg&q=85",
  web1: "https://images.unsplash.com/photo-1610465299993-e6675c9f9efa?crop=entropy&cs=srgb&fm=jpg&q=85",
  identity1: "https://images.pexels.com/photos/8489947/pexels-photo-8489947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  studio: "https://images.unsplash.com/photo-1753340328023-0097aa2b8e6f?crop=entropy&cs=srgb&fm=jpg&q=85",
  g1: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&q=85",
  g2: "https://images.pexels.com/photos/4125611/pexels-photo-4125611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  g3: "https://images.unsplash.com/photo-1790042200763-d715bb455b9a?crop=entropy&cs=srgb&fm=jpg&q=85",
  g4: "https://images.pexels.com/photos/34516665/pexels-photo-34516665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PROJECT_TYPES = [
  "Video Production",
  "Brand Identity Design",
  "Packaging Design",
  "Product Development",
  "Social Media Marketing",
  "Web Development",
  "Full brand build",
  "Something else",
];

export const BUDGETS = ["Under ₹1,00,000", "₹1L – ₹3L", "₹3L – ₹8L", "₹8L+", "Not sure yet"];

export const SERVICES = [
  {
    slug: "video-production",
    name: "Video Production",
    short: "Films, commercials & motion",
    tagline: "Films that hold the frame — and the room.",
    intro:
      "From first treatment to final grade, we produce cinematic film and product photography for brands with something to say — commercials, launch films, documentaries and motion systems built to be remembered.",
    heroImage: IMAGES.svcVideo,
    stat: { value: "140+", label: "films delivered" },
    deliverables: [
      { title: "Brand films & commercials", desc: "Hero films and spot campaigns, directed end-to-end: treatment, casting, shoot, edit, grade and sound." },
      { title: "Product & launch films", desc: "Tabletop, macro and CGI-assisted product stories that make features feel like fiction." },
      { title: "Documentary & founder stories", desc: "Longer-form pieces that put a human pulse behind the brand." },
      { title: "Motion design & title systems", desc: "Kinetic type, title sequences and motion languages that carry across every screen." },
      { title: "Post-production & finishing", desc: "Edit, colour grade, sound design and mastering — polished in-house, delivered everywhere." },
    ],
    packages: [
      { name: "Single Frame", price: "₹85,000", per: "onwards", blurb: "One hero film, start to finish.", features: ["1 hero film (60–90s)", "1 shoot day, core crew", "Licensed music + colour grade", "2 revision rounds", "Delivery in 3 weeks"] },
      { name: "Campaign", price: "₹2,40,000", per: "onwards", featured: true, blurb: "A hero film plus a full cutdown system.", features: ["1 hero film + 6 cutdowns", "2 shoot days, full crew", "Motion titles & captions", "9:16 and 1:1 masters", "3 revision rounds"] },
      { name: "Studio Retainer", price: "₹4,50,000", per: "/ month", blurb: "Your always-on film department.", features: ["1 shoot day every month", "12+ edits per month", "Priority scheduling", "Dedicated producer", "Quarterly film strategy"] },
    ],
    portfolio: [
      { title: "Afterlight — Launch Film", tag: "Commercial", image: IMAGES.afterlight },
      { title: "Echoes — Trailer Cut", tag: "Film", image: IMAGES.p4 },
      { title: "On Set — Unit Stills", tag: "Production", image: IMAGES.p2 },
    ],
    faqs: [
      { q: "How long does a typical film take?", a: "A single hero film runs about three weeks from sign-off to delivery; campaign systems run five to six. We lock a shoot date within ten days of kickoff." },
      { q: "Do you handle locations, casting and permits?", a: "Yes. Production management — locations, casting, crew, permits and insurance — is part of every engagement, never an add-on." },
      { q: "Who owns the footage?", a: "You do. Final masters and organised project files are yours; raw rushes are available on request at no extra cost." },
      { q: "Can you shoot outside our city?", a: "We travel. Crew and kit move across India and abroad; travel is billed transparently at cost." },
    ],
  },
  {
    slug: "brand-identity",
    name: "Brand Identity Design",
    short: "Strategy, marks & brand worlds",
    tagline: "Identities with a point of view.",
    intro:
      "We build brand worlds from the strategy up — logo design, naming, identity systems and brand strategy that give startups and growing companies a voice people recognise in the dark.",
    heroImage: IMAGES.svcBrand,
    stat: { value: "60+", label: "brands launched" },
    deliverables: [
      { title: "Strategy & positioning", desc: "Workshops, audience insight and a sharp platform everything else stands on." },
      { title: "Naming & verbal identity", desc: "Names, taglines and tone-of-voice guides that sound like you on your best day." },
      { title: "Logo & identity systems", desc: "Wordmarks, monograms, colour, type and layout systems built to flex." },
      { title: "Brand guidelines", desc: "A living playbook your team, printers and partners actually use." },
      { title: "Packaging & collateral", desc: "Boxes, labels, stationery and print pieces that make the brand physical." },
    ],
    packages: [
      { name: "The Mark", price: "₹65,000", per: "onwards", blurb: "A logo suite with a mini guide.", features: ["Primary + secondary marks", "Colour & type pairing", "3 distinct concepts", "2 refinement rounds", "Launch asset pack"] },
      { name: "Identity System", price: "₹1,60,000", per: "onwards", featured: true, blurb: "The full system, built to scale.", features: ["Strategy workshop", "Complete identity system", "40-page brand book", "Stationery + social kit", "3 refinement rounds"] },
      { name: "Brand World", price: "₹3,20,000", per: "onwards", blurb: "Identity, packaging and launch creative.", features: ["Everything in Identity System", "Packaging design (2 SKUs)", "Launch campaign creative", "Art direction for shoot", "90-day support"] },
    ],
    portfolio: [
      { title: "Nocturne FM — Identity", tag: "Identity", image: IMAGES.nocturne },
      { title: "Vantage — Wordmark", tag: "Logotype", image: IMAGES.identity1 },
      { title: "Afterlight — Brand World", tag: "Full build", image: IMAGES.afterlight },
    ],
    faqs: [
      { q: "How many concepts do we see?", a: "Three distinct directions, each fully realised — not three versions of one idea. We refine the chosen direction together." },
      { q: "What files do we receive?", a: "Everything: vector masters, web-ready exports, font licensing guidance and an organised asset library your team can self-serve from." },
      { q: "Do you work with existing logos?", a: "Yes — refresh engagements evolve what works and rebuild what doesn't. We're honest about which is which." },
      { q: "How long does a full identity take?", a: "Four to six weeks for a full system, eight when packaging and launch creative are involved." },
    ],
  },
  {
    slug: "packaging-design",
    name: "Packaging Design",
    short: "Food, FMCG & D2C packaging",
    tagline: "Packaging that sells before it's opened.",
    intro:
      "A packaging design company in Pune for brands that live on shelves — food packaging design, edible oil packaging and label design for food products, engineered from first label to full FMCG range.",
    heroImage: IMAGES.terraforma,
    stat: { value: "200+", label: "SKUs on shelf" },
    deliverables: [
      { title: "Label design for food products", desc: "Front-of-pack that stops the eye and back-of-pack that carries every mandatory mark — layouts with room for nutrition panels, barcodes and declarations." },
      { title: "Food & FMCG packaging systems", desc: "Range architecture, variant colour systems and SKU logic that let one product grow into a family without losing the shelf." },
      { title: "Edible oil & staples packaging", desc: "Pouches, bottles, tins and jars — designed for Indian retail realities, from kirana shelf to quick-commerce thumbnail." },
      { title: "Structural design & dielines", desc: "Custom structures, dielines and material specs your printer can actually run — no surprises between screen and press." },
      { title: "Print production & vendor management", desc: "Print-ready artwork, colour proofs and press checks. We sit with the printer so the gold stays gold." },
    ],
    packages: [
      { name: "Label Sprint", price: "₹35,000", per: "onwards", blurb: "One product, shelf-ready.", features: ["1 label or pouch design", "2 distinct concepts", "Print-ready artwork + dieline", "Mandatory-mark layout", "2 revision rounds"] },
      { name: "Pack System", price: "₹1,40,000", per: "onwards", featured: true, blurb: "A complete pack, done properly.", features: ["Full packaging design (1 SKU)", "Structure + dieline engineering", "Range-ready design system", "Print proofs & press check", "3 revision rounds"] },
      { name: "Range & Rollout", price: "₹3,00,000", per: "onwards", blurb: "A whole family, launched at once.", features: ["Up to 8 SKUs designed", "Variant & range architecture", "Vendor + printer management", "Launch photography direction", "90-day rollout support"] },
    ],
    portfolio: [
      { title: "Terra Forma — Pack Suite", tag: "Packaging", image: IMAGES.terraforma },
      { title: "Bloom Box — Labels", tag: "Label design", image: IMAGES.g3 },
      { title: "Afterlight — Bottles", tag: "Structural", image: IMAGES.afterlight },
    ],
    faqs: [
      { q: "Do you handle FSSAI and legal labelling requirements?", a: "We design to the requirements you confirm with your compliance advisor — every mandatory mark, panel and declaration gets its place, and the artwork stays print-ready." },
      { q: "Can you work with our existing printer or manufacturer?", a: "Yes — we coordinate directly with your printer or packer on specs, materials and proofs. If you don't have one, we bring vetted vendors from our network." },
      { q: "What do you need from us to start?", a: "The product, the pack format (or a rough idea), your compliance details and any brand assets you already have. If the brand isn't built yet, we pair this with our identity work." },
      { q: "How long does packaging design take?", a: "A single label runs about two weeks; a full pack system four to five; ranges are scheduled per SKU count. Print timelines are planned with the vendor up front." },
    ],
  },
  {
    slug: "product-development",
    name: "Product Development",
    short: "Concept to shelf",
    tagline: "Objects people want to hold.",
    intro:
      "We take products from sketch to shelf — concept design, prototyping and launch assets, developed with manufacturers so the idea survives production.",
    heroImage: IMAGES.svcProduct,
    stat: { value: "35+", label: "products shipped" },
    deliverables: [
      { title: "Concept & industrial design", desc: "Form studies, CMF direction and 3D concepts that give the product its character." },
      { title: "Packaging engineering", desc: "Dielines, materials and structural design — from edible oil bottles to food-safe labels — engineered to survive the supply chain." },
      { title: "Prototyping", desc: "Looks-like and works-like models for testing, pitching and photography." },
      { title: "Design-for-manufacture liaison", desc: "We speak factory: tolerances, tooling notes and vendor coordination." },
      { title: "Launch asset suites", desc: "Renders, photography direction and unboxing films ready for release day." },
    ],
    packages: [
      { name: "Concept Sprint", price: "₹95,000", per: "2 weeks", blurb: "Pressure-test the idea fast.", features: ["3 concept directions", "CMF boards", "Hero renders", "Feasibility notes", "Investor-ready deck pages"] },
      { name: "Product & Pack", price: "₹2,80,000", per: "onwards", featured: true, blurb: "The product and its packaging, production-ready.", features: ["Full concept development", "Packaging + dielines", "2 prototype rounds", "DFM documentation", "Launch renders"] },
      { name: "Full Launch", price: "₹5,00,000", per: "onwards", blurb: "Concept to release day, handled.", features: ["Everything in Product & Pack", "Unboxing & product film", "Photography direction", "E-commerce asset suite", "Vendor coordination"] },
    ],
    portfolio: [
      { title: "Terra Forma — Product Line", tag: "Product", image: IMAGES.terraforma },
      { title: "Orbit Objects — Concept", tag: "Industrial", image: IMAGES.g2 },
      { title: "Bloom Box — Pack Suite", tag: "Packaging", image: IMAGES.g3 },
    ],
    faqs: [
      { q: "Do you manufacture too?", a: "We design and coordinate; manufacturing stays with vetted vendors. We manage the relationship so specs don't get lost in translation." },
      { q: "Can you work from an existing prototype?", a: "Absolutely. We often step in to refine form, engineer packaging and prepare products for launch." },
      { q: "What do we need to start?", a: "A problem worth solving. A sketch, a sample or just a sentence — the Concept Sprint is built for all three." },
      { q: "Who owns the IP?", a: "You do, fully. All design files, renders and documentation transfer to you on final payment." },
    ],
  },
  {
    slug: "social-media-marketing",
    name: "Social Media Marketing",
    short: "Editorial social engines",
    tagline: "Feeds worth following.",
    intro:
      "We run social like an editorial desk — strategy, shoot days, calendars, community and product launch campaigns, measured against numbers that actually matter to the business.",
    heroImage: IMAGES.svcSocial,
    stat: { value: "2.1M+", label: "followers grown" },
    deliverables: [
      { title: "Channel strategy & playbooks", desc: "Positioning, pillars and formats per platform, written down and agreed." },
      { title: "Content systems & calendars", desc: "Monthly calendars with room to react — planned, not panicked." },
      { title: "Shoot days — reels & stills", desc: "One production day, a month of assets: reels, stills and stories in every ratio." },
      { title: "Community & campaign management", desc: "Posting, engagement and paid-boost coordination handled end-to-end." },
      { title: "Reporting & growth loops", desc: "Monthly reporting that reads like insight, not a spreadsheet apology." },
    ],
    packages: [
      { name: "Starter", price: "₹55,000", per: "/ month", blurb: "For brands finding their voice.", features: ["12 posts / month", "1 shoot day / quarter", "Monthly content calendar", "Community mgmt (5 days/wk)", "Monthly insight report"] },
      { name: "Growth", price: "₹1,20,000", per: "/ month", featured: true, blurb: "For brands ready to compound.", features: ["20 posts / month", "1 shoot day / month", "Reels + stills in all ratios", "Daily community mgmt", "Boosted campaign coordination"] },
      { name: "Editorial House", price: "₹2,40,000", per: "/ month", blurb: "Your brand, published like a magazine.", features: ["30+ posts / month", "2 shoot days / month", "Always-on community", "Quarterly campaign concepts", "Dedicated strategist"] },
    ],
    portfolio: [
      { title: "Pulse — Second Wind", tag: "Campaign", image: IMAGES.pulse },
      { title: "Midnight Menu — Series", tag: "Content", image: IMAGES.social1 },
      { title: "Static Club — Socials", tag: "Editorial", image: IMAGES.social2 },
    ],
    faqs: [
      { q: "Do you create the content, or do we?", a: "We do. Shoot days produce a month of native assets — you're approving, not filming." },
      { q: "How soon do results show?", a: "Consistency compounds: most accounts see meaningful lift by month three. We set expectations per platform at kickoff." },
      { q: "Can you run paid campaigns too?", a: "Yes — organic and boosted work together here. Ad spend is billed directly to you, always transparent." },
      { q: "Which platforms do you cover?", a: "Instagram, YouTube, LinkedIn and X. We go deep on fewer platforms rather than thin on many." },
    ],
  },
  {
    slug: "web-development",
    name: "Web Development",
    short: "Sites & stores with a pulse",
    tagline: "Websites that behave like films.",
    intro:
      "We design and build D2C websites and online stores with cinematic pacing — fast, expressive and engineered to convert attention into orders.",
    heroImage: IMAGES.svcWeb,
    stat: { value: "50+", label: "sites shipped" },
    deliverables: [
      { title: "Marketing sites & landing pages", desc: "High-craft pages with motion, narrative and ruthless load times." },
      { title: "E-commerce experiences", desc: "Stores that feel like flagship retail, built on proven commerce stacks." },
      { title: "Design systems in code", desc: "Component libraries your team can ship with, documented and reusable." },
      { title: "CMS builds", desc: "Edit-everything backends so marketing never waits on a developer." },
      { title: "Performance & SEO foundations", desc: "Core Web Vitals in the green, structured data and analytics wired from day one." },
    ],
    packages: [
      { name: "Landing", price: "₹75,000", per: "onwards", blurb: "One page, perfectly built.", features: ["Custom design + build", "Motion & interactions", "CMS-editable content", "Analytics setup", "2-week delivery"] },
      { name: "Site", price: "₹1,90,000", per: "onwards", featured: true, blurb: "A full marketing site.", features: ["Up to 8 pages", "Design system in code", "CMS + blog", "SEO foundations", "4–6 week delivery"] },
      { name: "Commerce", price: "₹3,50,000", per: "onwards", blurb: "A store with a pulse.", features: ["Full storefront", "Product & collection templates", "Payments + shipping setup", "Email capture flows", "30-day launch support"] },
    ],
    portfolio: [
      { title: "Pulse — Webstore", tag: "Commerce", image: IMAGES.web1 },
      { title: "Kiln & Co. — Site", tag: "Marketing", image: IMAGES.p1 },
      { title: "Northgate — Corporate", tag: "Web", image: IMAGES.g1 },
    ],
    faqs: [
      { q: "What stack do you build on?", a: "Modern React front-ends with a headless CMS, or Shopify for commerce. We recommend after hearing the requirement, never before." },
      { q: "Can you redesign our existing site?", a: "Yes — most engagements are redesigns. We audit what converts, keep it, and rebuild the rest." },
      { q: "Do you write the copy?", a: "We shape it. Full copywriting is available as an add-on, or we art-direct your drafts into final." },
      { q: "What happens after launch?", a: "Thirty days of fixes and tweaks are included; care plans cover updates, backups and small evolutions after that." },
    ],
  },
];

// To publish a real case study: replace the fields below (title, client, year, tags,
// scope, summary, challenge/approach/outcome, stats, credits) and point heroImage,
// gallery and showreelPoster at the project's real assets. Add showreelUrl: "https://…"
// (an .mp4 or stream URL) and the case study page automatically swaps the poster
// frame for a full video player.
export const CASE_STUDIES = [
  {
    slug: "afterlight",
    title: "Afterlight",
    client: "Afterlight Parfums",
    year: "2025",
    tags: ["Video", "Identity"],
    scope: "Full brand build",
    heroImage: IMAGES.afterlight,
    showreelPoster: IMAGES.g4,
    reelLength: "90 sec",
    summary:
      "A fragrance house with no name became Afterlight — a full brand world, from the wordmark on the bottle to the film that launched it.",
    challenge:
      "The founders had a remarkable product and four weeks to launch. No name, no identity, no imagery — just two fragrances and a conviction that scent could be marketed like cinema.",
    approach:
      "We built the brand backwards from a feeling: the last light of the day. Naming, identity and packaging ran in parallel with a launch film shot in a single night — smoke, glass and one beam of light.",
    outcome:
      "Afterlight sold through its first production run in launch week. The film carried the brand further than any media budget could have — shared, saved and written about.",
    stats: [
      { value: "+212%", label: "launch-week sell-through" },
      { value: "4.8M", label: "organic film views" },
      { value: "11", label: "SKUs at launch" },
    ],
    credits: [
      { role: "Director", name: "Arjun Mehta" },
      { role: "Brand Lead", name: "Sana Qureshi" },
      { role: "Producer", name: "Devika Rao" },
      { role: "Director of Photography", name: "Kabir Anand" },
      { role: "Edit & Grade", name: "Oasis Post" },
      { role: "Photography", name: "Ishaan Bhatt" },
    ],
    gallery: [IMAGES.afterlight, IMAGES.g4, IMAGES.p3, IMAGES.g2],
  },
  {
    slug: "nocturne-fm",
    title: "Nocturne FM",
    client: "Nocturne FM",
    year: "2024",
    tags: ["Identity", "Social"],
    scope: "Identity + social system",
    heroImage: IMAGES.nocturne,
    showreelPoster: IMAGES.g3,
    reelLength: "60 sec",
    summary:
      "An independent night-radio station got an identity as moody as its playlist — and a social engine that grew it from zero into a scene.",
    challenge:
      "Nocturne had loyal late-night listeners but no visual presence. Every post looked different, and growth had flatlined at a few hundred followers.",
    approach:
      "We designed a glow-in-the-dark identity — phosphorescent type on deep black — then built a content system around it: lyric cards, session clips and a weekly after-hours reel format.",
    outcome:
      "Nine months later, Nocturne is a recognised name in three cities, with live takeovers selling out and labels pitching their artists for sessions.",
    stats: [
      { value: "120K", label: "followers in 9 months" },
      { value: "38%", label: "avg. reel engagement" },
      { value: "3", label: "city takeovers sold out" },
    ],
    credits: [
      { role: "Brand Lead", name: "Sana Qureshi" },
      { role: "Social Strategy", name: "Meera Iyer" },
      { role: "Motion", name: "Oasis Post" },
      { role: "Photography", name: "Ishaan Bhatt" },
    ],
    gallery: [IMAGES.nocturne, IMAGES.social1, IMAGES.g3, IMAGES.p3],
  },
  {
    slug: "terraforma",
    title: "Terra Forma",
    client: "Terra Forma Ceramics",
    year: "2024",
    tags: ["Product"],
    scope: "Product development & packaging",
    heroImage: IMAGES.terraforma,
    showreelPoster: IMAGES.g2,
    reelLength: "75 sec",
    summary:
      "A ceramicist's studio practice became a product line — fourteen objects, engineered packaging and a launch that sold through twice.",
    challenge:
      "Every Terra Forma piece was one-of-one. The founder wanted reach without losing the handmade soul — and packaging that could survive courier networks.",
    approach:
      "We developed a modular forms system so pieces feel handmade but produce consistently, then engineered molded-pulp packaging that costs less than the bubble wrap it replaced.",
    outcome:
      "The line launched at two design fairs and online simultaneously, sold through its first run in five weeks, and picked up two national design awards.",
    stats: [
      { value: "14", label: "products designed & shipped" },
      { value: "−22%", label: "packaging cost" },
      { value: "2", label: "national design awards" },
    ],
    credits: [
      { role: "Product Lead", name: "Rahul Nair" },
      { role: "Packaging", name: "Anaya Joshi" },
      { role: "Photography", name: "Ishaan Bhatt" },
      { role: "Film", name: "Arjun Mehta" },
    ],
    gallery: [IMAGES.terraforma, IMAGES.g2, IMAGES.g4, IMAGES.p4],
  },
  {
    slug: "pulse-athletics",
    title: "Pulse Athletics",
    client: "Pulse Athletics",
    year: "2023",
    tags: ["Social", "Web"],
    scope: "Campaign + webstore",
    heroImage: IMAGES.pulse,
    showreelPoster: IMAGES.g1,
    reelLength: "2 min",
    summary:
      "A homegrown activewear label relaunched with a campaign shot like a title sequence — and a store that finally converted the hype.",
    challenge:
      "Pulse had hype on social and a website that leaked it. Bounce rates were brutal, and every drop under-sold despite the audience.",
    approach:
      "We shot the Second Wind campaign in one night with three athletes, cut it into a six-week social rollout, and rebuilt the store around the film — product pages open like scenes.",
    outcome:
      "The drop sold out in six weeks. The store now converts at three times its old rate, and the campaign language is how the community talks back to the brand.",
    stats: [
      { value: "+340%", label: "store conversion" },
      { value: "9.2M", label: "campaign reach" },
      { value: "6 wks", label: "to sellout" },
    ],
    credits: [
      { role: "Director", name: "Arjun Mehta" },
      { role: "Web Lead", name: "Tara Menon" },
      { role: "Social Strategy", name: "Meera Iyer" },
      { role: "Director of Photography", name: "Kabir Anand" },
    ],
    gallery: [IMAGES.pulse, IMAGES.web1, IMAGES.social2, IMAGES.g1],
  },
];

export const PORTFOLIO = [
  { title: "Midnight Menu", category: "Social", tags: ["Social"], year: "2025", image: IMAGES.social1, size: "tall" },
  { title: "Kiln & Co. Store", category: "Web", tags: ["Web"], year: "2024", image: IMAGES.web1, size: "standard" },
  { title: "Vantage Wordmark", category: "Identity", tags: ["Identity"], year: "2025", image: IMAGES.identity1, size: "standard" },
  { title: "Echoes — Trailer", category: "Video", tags: ["Video"], year: "2024", image: IMAGES.p4, size: "wide" },
  { title: "Orbit Objects", category: "Product", tags: ["Product"], year: "2025", image: IMAGES.g2, size: "standard" },
  { title: "Static Club", category: "Social", tags: ["Social"], year: "2023", image: IMAGES.social2, size: "standard" },
  { title: "Northgate Site", category: "Web", tags: ["Web"], year: "2024", image: IMAGES.g1, size: "standard" },
  { title: "Bloom Box", category: "Product", tags: ["Product"], year: "2023", image: IMAGES.g3, size: "tall" },
];

export const FILTERS = ["All", "Video", "Identity", "Product", "Social", "Web"];

// Studio journal — essays shown at /journal. Add a new object to publish a new essay.
export const JOURNAL = [
  {
    slug: "why-brand-films-fall-flat",
    title: "Why most brand films fall flat",
    tag: "Film",
    date: "18 Jun 2026",
    readTime: "5 min read",
    image: IMAGES.g1,
    excerpt: "The problem is rarely the camera. It's that nobody decided what the film was for.",
    body: [
      "Every week a brand releases a film that cost more than a car and lands with the impact of a screensaver. The footage is beautiful. Nobody remembers it. The instinct is to blame the algorithm, the audience, the budget. The real problem happened months earlier, in a meeting where nobody asked the only question that matters: what is this film for?",
      "A film is not a container for everything the company wants to say. It is a single argument, made with light and sound. The moment a brief contains three messages, the film contains none. Our first job on any production is subtraction — cutting the brief down to the one sentence we would tattoo on the wall.",
      "That sentence changes everything downstream. If the film exists to make a premium price feel justified, you shoot texture, patience and restraint. If it exists to recruit, you shoot people, not products. If it exists to launch, you shoot tension and release. Same camera. Completely different film.",
      "The second failure is politeness. Brands sand off every edge until the film offends no one and moves no one. The work people share is never the work that pleased every stakeholder — it is the work that had a point of view and kept it.",
      "None of this requires a bigger budget. Some of the most effective films we have made were one location, one night, one idea. Constraint concentrates. Money spent rescuing a confused brief is money spent twice.",
      "So before the treatment, before the moodboard, before the quote — write the sentence. If you cannot, that is the project. Everything else is logistics.",
    ],
  },
  {
    slug: "the-logo-is-not-the-brand",
    title: "The logo is not the brand",
    tag: "Identity",
    date: "02 May 2026",
    readTime: "4 min read",
    image: IMAGES.identity1,
    excerpt: "A mark can be perfect and the brand still forgettable. Identity is a system of decisions, not a file.",
    body: [
      "Founders arrive with a folder of logo references and a deadline. What they actually need is harder to screenshot: a way of making a thousand future decisions without a meeting.",
      "A brand is what happens when nobody from the founding team is in the room. The packaging a supplier substitutes, the caption an intern writes, the proposal a partner formats at midnight. Identity systems exist so all of those moments feel like they came from the same place.",
      "That is why we build systems, not marks. The wordmark matters — but so does the grid it sits on, the type it argues with, the motion it moves with, the words it would never use. A logo is a signature. The system is the handwriting.",
      "The test we use: remove the logo from every touchpoint. Would anyone still know it is you? If the answer is no, you have a label, not a brand.",
      "None of this means the craft of the mark does not matter. It means the mark is the beginning of the conversation, not the deliverable. The deliverable is coherence — the feeling that everything a company makes was made by the same pair of hands.",
      "Get that right and the logo can be almost anything. Get it wrong and no logo can save you.",
    ],
  },
  {
    slug: "anatomy-of-a-shoot-day",
    title: "The anatomy of a shoot day",
    tag: "Behind the scenes",
    date: "21 Mar 2026",
    readTime: "6 min read",
    image: IMAGES.p2,
    excerpt: "Call time is 6 AM. The film is made or lost in the two hours before anyone rolls a camera.",
    body: [
      "People imagine a shoot day as chaos punctuated by magic. In practice it is the opposite: a machine built to protect ten minutes of magic from eleven hours of logistics.",
      "The day starts before the day. Call sheets out by eight the night before, kit checked twice, the location walked with the light in mind. The best crews look unhurried because the hurrying happened yesterday.",
      "By 6 AM the first frame of the day is already decided. We block the hardest setup first — not because it is heroic, but because everyone's judgement is freshest and the light forgives early.",
      "Midday is where films are lost. Energy dips, lunch runs long, and the schedule quietly slides an hour. Our producers guard the shot list like a budget, because it is one: every minute spent re-lighting a scene that did not need re-lighting is a minute stolen from the scene that did.",
      "The last hour is golden in both senses. Whatever the day cost, whatever went wrong, the final setup gets full attention — because audiences remember endings, and so do clients.",
      "Then the wrap that matters most: footage backed up twice before anyone leaves, selects marked the same night while the day is still warm. The edit does not start in the edit suite. It starts here.",
      "None of this is glamorous. That is the point. The glamour is on the screen, and it is made of exactly this.",
    ],
  },
];
